<template>
  <v-container>
    <v-row
      align="center"
      justify="center"
      class="login-container"
    >
      <v-col 
        cols="12" 
        class="d-flex justify-center"
      >
        <v-img
          src="https://brodelec.fr/images/logo.png"
          contain
          class="login-logo"
        />
      </v-col>
      <transition name="slide-fade" mode="out-in">
        <router-view/>
      </transition>
    </v-row>
  </v-container>
</template>

<script>
  // LIBRARY
  import { validationMixin } from 'vuelidate'
  import { required, email } from 'vuelidate/lib/validators'
  // EVENTS
  import { EventBus } from '@/main.js'
  import { AUTH_RESET_PSWD } from '@/store/actions/auth'
  import { LOADING, LOADED } from '@/store/actions/general'

  export default {
    name: 'User',

    mounted() {
      EventBus.$emit(LOADED)
    }
  }
</script>

<style scoped>
  .red-text {
    color: red;
  }
  .login-logo {
    width: 100px;
    height: 100px;
  }
  .login-container {
    height: 500px;
  }

  @media (min-width: 900px) {
    .login-logo {
      height: 200px;
    }
    .login-container {
      height: 600px;
    }
  } 
  .slide-fade-enter-active {
    transition: all .2s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter {
    transform: translateY(15px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateY(-15px);
    opacity: 0;
  }
</style>